import React from 'react';
import '../css/Toggle.css';

const Toggle = ({ value, onChange, options = ['nee', 'ja'], disabled = false }) => {
  return (
    <div className="toggle-radio-group" role="radiogroup">
      {options.map((option) => {
        const selected = value === option;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`toggle-radio ${selected ? 'selected' : ''}`}
            onClick={() => !disabled && onChange(option)}
            disabled={disabled}
          >
            <span className="toggle-radio-dot" aria-hidden="true" />
            <span className="toggle-radio-label">
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default Toggle;
